if ($('.highlight-keywords .form-textfield-input').length) {
	highlightText($('.highlight-keywords .form-textfield-input').attr("data-keyword").split(" "));
}

function highlightText(query) {
	$('.search-results__result__text').each(function () {
		var text = this.innerHTML.replace(/<span\sclass="highlight">|<\/span>/g, "");
		var category = '<p class="search-results__result__pill">' + text.split('<p class="search-results__result__pill">')[1];
		text = text.split('<p class="search-results__result__pill">')[0];

		function replacer(match, p1, p2, p3, offset, string) {
			return '<span class="highlight">' + match + '</span>';
		}
		
		query.forEach(function (value, index) {
			var regex = new RegExp(value, "gi");

			text = text.replace(regex, replacer);
		});

		this.innerHTML = text + category;
	});
}